import { DropdownMenuButton } from "@jutro/components";
import { DropdownMenuLink } from '@jutro/router';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CONSTANTS } from "wmic-pe-portals-utils-js";
import { TranslatorContext } from '@jutro/locale';
import { useContext } from 'react';
import messages from './WMICPUPAddHouseholdMemberDropdownMenu.messages.js';

const canContactBeAddedToHouseholdMembers = (contact, householdMembers) => {
    return contact.subtype.toLowerCase() === CONSTANTS.Person.toLowerCase()
        && (_.isEmpty(householdMembers)
            || householdMembers.every(householdMember => {
                return householdMember?.person?.publicID !== contact?.contactPublicID && householdMember?.person?.publicID !== contact?.publicID;
            }));
};

function WMICPUPAddHouseholdMemberDropdownMenu(props) {
    const {
        primaryNamedInsured,
        additionalNamedInsureds,
        isEditing,
        onClick,
        householdMembers
    } = props;

    const translator = useContext(TranslatorContext);

    const nameInsureds = additionalNamedInsureds ? additionalNamedInsureds.slice() : [];

    if (primaryNamedInsured){
        nameInsureds.push(primaryNamedInsured);
    }
    
    return (
        <DropdownMenuButton
            id="addNewHouseholdMemberButton"
            buttonText={translator(messages.addHouseholdMember)}
            icon="mi-add"
            disabled={isEditing}>
            {nameInsureds?.map((ni) => (
                canContactBeAddedToHouseholdMembers(ni, householdMembers) && <DropdownMenuLink
                    onClick={() => onClick(householdMembers.length, ni)}>
                    {ni.displayName}
                </DropdownMenuLink>
            ))}
            <DropdownMenuLink onClick={() => onClick(
                householdMembers?.length
            )}>{translator(messages.addHouseholdMember)}</DropdownMenuLink>
        </DropdownMenuButton>
    );
}

WMICPUPAddHouseholdMemberDropdownMenu.propTypes = {
    primaryNamedInsured: PropTypes.object.isRequired,
    additionalNamedInsureds: PropTypes.shape([]).isRequired,
    isEditing: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    householdMembers: PropTypes.shape([]).isRequired,
};

export default WMICPUPAddHouseholdMemberDropdownMenu;
